import { resolveStoredFileUrl } from "utils/storedFileUrl";
import { Icon, MenuItem, Select, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftInputNumber from "components/SoftInputNumberUpgrade";
import { formatMoneyPunto, recortarTexto } from "utils/formatters";
import { getUproColor } from "utils/colors";
import { formatMoneyPuntoDecimal } from "utils/formatters";
import SoftBadge from "components/SoftBadge";
import borders from "assets/theme/base/borders";
import colors from "assets/theme/base/colors";
import { mpPorPack } from "./reglasPedido";
import { cambiarUnidadCompra } from "./unidadCompra";
import { nombreCompraDetalle } from "utils/presentacionCompra";

export const getColumns = (tipoDetalle, allowEdit, menu, callbacks = {}) => {
    const { borderWidth } = borders;
    const { light } = colors;

    if (tipoDetalle === "Productos") {
        const baseColumns = [
            {
                field: "nombre",
                headerName: "Producto",
                align: "left",
                width: "30%",
                sortable: true,
                renderHeader: (column, isCurrentSort, direction) => (
                    <SoftBox
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        gap={1}
                        sx={{
                            width: "100%",
                            overflow: "hidden",
                            minWidth: 0,
                        }}
                    >
                        <SoftBox display="flex" alignItems="center" gap={1}>
                            <SoftTypography
                                variant="caption"
                                fontWeight="bold"
                                textTransform="uppercase"
                                color="dark"
                                sx={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    flex: 1,
                                    minWidth: 0,
                                }}
                                title={column.headerName}
                            >
                                {column.headerName}
                            </SoftTypography>
                        </SoftBox>
                    </SoftBox>
                ),
                renderCell: (item, index) => (
                    <Tooltip title={item?.materiaPrima?.nombre} placement="bottom">
                        <SoftBox sx={{ width: '100%' }}>
                            {allowEdit ? (<SoftInput
                                name='nombreCompra'
                                multiline
                                minRows={2}
                                sx={{ alignItems: 'center', justifyContent: 'center', width: '100%' }}
                                value={nombreCompraDetalle(item)}
                                onChange={(e) => {
                                    const nuevo = {
                                        ...item,
                                        nombreCompra: e.target.value,
                                    };
                                    if (callbacks && callbacks.handleUpdateDetalle) callbacks.handleUpdateDetalle(nuevo, item.id);
                                }}
                                disabled={!item?.requierePack}
                                inputProps={{ disabled: !item?.requierePack }}
                            />) : (
                                <SoftTypography variant="h6" align="center" fontWeight="bold" sx={{ whiteSpace: 'normal', overflowWrap: 'anywhere' }}>
                                    {nombreCompraDetalle(item)}
                                </SoftTypography>
                            )}
                        </SoftBox>
                    </Tooltip>
                )
            },
            {
                field: "requierePack",
                headerName: "Cambiar unidad?",
                align: "center",
                width: "15%",
                sortable: false,
                renderHeader: (column, isCurrentSort, direction) => (
                    <SoftBox
                        display="flex"
                        alignItems="center"
                        justifyContent="left"
                        gap={1}
                        sx={{
                            width: "100%",
                            overflow: "hidden",
                            minWidth: 0,
                            pl: 1
                        }}
                    >
                        <SoftBox display="flex" alignItems="center" gap={1}>
                            <SoftTypography
                                variant="caption"
                                fontWeight="bold"
                                textTransform="uppercase"
                                color="dark"
                                sx={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "wrap",
                                    flex: 1,
                                    minWidth: 0,
                                }}
                                title={column.headerName}
                            >
                                {column.headerName}
                            </SoftTypography>
                        </SoftBox>
                    </SoftBox>
                ),
                renderCell: (item, index) => (
                    <SoftBox display="flex" alignItems="center" justifyContent="center" sx={{ width: '100%', minWidth: 0 }}>
                        <SoftBox
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            gap={1}
                            sx={{
                                width: "100%",
                                overflow: "hidden",
                                minWidth: 0,
                            }}
                        >
                            {allowEdit ? (
                                <Select
                                    name="requierePack"
                                    value={item?.requierePack ? 'SI' : 'NO'}
                                    onChange={(e) => {
                                        const val = e.target.value === 'SI';
                                        const nuevo = cambiarUnidadCompra(item, {
                                            requierePack: val,
                                            unidadPack: val ? (item.unidadPack || item._unidadPackAnterior || null) : null,
                                            _unidadPackAnterior: item.unidadPack || item._unidadPackAnterior,
                                        });
                                        if (callbacks && callbacks.handleUpdateDetalle) callbacks.handleUpdateDetalle(nuevo, item.id);
                                    }}
                                    size="small"
                                >
                                    <MenuItem value={'SI'}>SI</MenuItem>
                                    <MenuItem value={'NO'}>NO</MenuItem>
                                </Select>)
                                : (
                                    <SoftTypography variant="button" color="secondary">
                                        {item?.requierePack ? 'SI' : 'NO'}
                                    </SoftTypography>
                                )
                            }
                        </SoftBox>
                        {allowEdit && (<Tooltip title="Establecer equivalencia" placement="top">
                            <Icon
                                fontSize="medium"
                                sx={{ cursor: item?.requierePack ? "pointer" : "not-allowed", ml: .5, opacity: item?.requierePack ? 1 : .4 }}
                                onClick={() => {
                                    if (!item?.requierePack) return;
                                    if (callbacks && callbacks.openEquivalenciaDialog) callbacks.openEquivalenciaDialog(item.id);
                                }}
                            >
                                change_circle
                            </Icon>
                        </Tooltip>)}
                    </SoftBox>
                )
            },
            {
                field: "cantidad",
                headerName: "Cantidad",
                align: "center",
                // width: "7%",
                sortable: true,
                renderHeader: (column, isCurrentSort, direction) => (
                    <SoftBox
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        gap={1}
                        sx={{
                            width: "100%",
                            overflow: "hidden",
                            minWidth: 0,
                        }}
                    >
                        <SoftBox display="flex" alignItems="center" gap={1}>
                            <SoftTypography
                                variant="caption"
                                fontWeight="bold"
                                textTransform="uppercase"
                                color="dark"
                                sx={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    flex: 1,
                                    minWidth: 0,
                                }}
                                title={column.headerName}
                            >
                                {column.headerName}
                            </SoftTypography>
                        </SoftBox>
                    </SoftBox>
                ),
                renderCell: (item, index) => (
                    <Tooltip
                        title={(() => {
                            if (!item?.requierePack) return "No requiere equivalencia";
                            const unidadMP = item?.materiaPrima?.tipoUnidad?.abreviatura || item?.materiaPrima?.tipoUnidad?.nombre || item?.materiaPrima?.tipoUnidad || '';
                            if (!item?.unidadPack) return unidadMP;
                            const packs = Math.max(1, item?.equivalenciaPack?.packs || 1);
                            const mp = Number(item?.equivalenciaPack?.materiaPrima ?? 1);
                            const unidadPack = item?.unidadPack || "";
                            return `${packs} ${unidadPack} equivalen a ${mp} ${unidadMP}`;
                        })()}
                        placement="top"
                    >
                        <SoftBox sx={{ width: '100%', position: 'relative' }}>
                            {allowEdit ? (
                                <SoftBox display="flex" alignItems="center" gap={1} justifyContent="center">
                                    <SoftInputNumber
                                        placeholder="Cantidad"
                                        name="cantidad"
                                        value={item?.cantidad}
                                        onChange={(e) => {
                                            const valRaw = Number(e.target.value);
                                            const val = isNaN(valRaw) ? 0 : valRaw;
                                            const nuevo = {
                                                ...item,
                                                materiaPrima: { ...item.materiaPrima },
                                                cantidad: val
                                            };
                                            delete nuevo._cantidadSinRedondear;
                                            delete nuevo._cantidadRedondeadaManual;
                                            if (nuevo?.requierePack) {
                                                // cantidad = packs; totalMP = packs * unidades por pack
                                                nuevo.totalMP = val * mpPorPack(nuevo);
                                            } else {
                                                // cantidad = MP
                                                // si hay fuentesPF, calcular ajusteManual como diferencia
                                                const sumFuentes = (Array.isArray(nuevo?.fuentesPF) ? nuevo.fuentesPF : []).reduce((acc, f) => acc + (Number(f?.cantidadMP) || 0), 0);
                                                nuevo.ajusteManual = val - sumFuentes;
                                                nuevo.totalMP = val;
                                            }
                                            if (callbacks && callbacks.handleUpdateDetalle) callbacks.handleUpdateDetalle(nuevo, item.id);
                                        }}
                                    />
                                    <SoftTypography variant="button" color="secondary">
                                        {item?.requierePack && item?.unidadPack ? item?.unidadPack : item?.materiaPrima?.tipoUnidad?.abreviatura || item?.materiaPrima?.tipoUnidad?.nombre || item?.materiaPrima?.tipoUnidad || 'Sin especificar'}
                                    </SoftTypography>
                                    {
                                        (Array.isArray(item?.fuentesPF) && item?.fuentesPF?.length > 0) && (
                                            <SoftBox
                                                sx={{
                                                    position: 'absolute',
                                                    top: -1,
                                                    right: item.requierePack ? 60 : 30,
                                                    zIndex: 1,
                                                    // pointerEvents: 'none',
                                                }}
                                            >
                                                <Tooltip title={`Cantidad de fuentes`} placement="bottom">
                                                    <SoftBadge
                                                        color="info"
                                                        variant="gradient"
                                                        size="xs"
                                                        badgeContent={item?.fuentesPF?.length > 0 ? `+${item?.fuentesPF?.length}` : ""}
                                                    />
                                                </Tooltip>
                                            </SoftBox>
                                        )}
                                </SoftBox>
                            ) : (
                                <SoftBox display="flex" alignItems="center" gap={1} justifyContent="center">
                                    <SoftTypography variant="button" fontWeight="medium">
                                        {item?.cantidad}
                                    </SoftTypography>
                                    <SoftTypography variant="button" color="secondary">
                                        {item?.requierePack && item?.unidadPack ? item?.unidadPack : item?.materiaPrima?.tipoUnidad?.abreviatura || item?.materiaPrima?.tipoUnidad?.nombre || item?.materiaPrima?.tipoUnidad || 'Sin especificar'}
                                    </SoftTypography>
                                </SoftBox>
                            )}
                        </SoftBox>
                    </Tooltip>
                )
            },

            {
                field: "precioEstimado",
                headerName: "Precio estimado",
                align: "center",
                // width: "150px",
                sortable: true,
                renderHeader: (column, isCurrentSort, direction) => (
                    <SoftBox
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        gap={1}
                        sx={{
                            width: "100%",
                            overflow: "hidden",
                            minWidth: 0,
                        }}
                    >
                        <SoftBox display="flex" alignItems="center" gap={1}>
                            <SoftTypography
                                variant="caption"
                                fontWeight="bold"
                                textTransform="uppercase"
                                color="dark"
                                sx={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "wrap",
                                    flex: 1,
                                    minWidth: 0,
                                }}
                                title={column.headerName}
                            >
                                {column.headerName}
                            </SoftTypography>
                        </SoftBox>
                    </SoftBox>
                ),
                renderCell: (item) => (
                    <Tooltip title={(item?.cantidad > 1 || item?.requierePack) ? `Precio base: $${formatMoneyPuntoDecimal(item?.materiaPrima?.precio)}` : ""} placement="top">
                        <SoftBox sx={{ width: '100%' }}>
                            {allowEdit ? (
                                <SoftInputNumber
                                    placeholder="Precio estimado"
                                    name="precioEstimado"
                                    value={item?.precioEstimado ?? item?.materiaPrima?.precio ?? 0}
                                    onChange={(e) => {
                                        const raw = Number(e.target.value);
                                        const val = isNaN(raw) || raw < 0 ? 0 : raw;
                                        const nuevo = {
                                            ...item,
                                            materiaPrima: { ...item.materiaPrima },
                                            precioEstimado: val,
                                        };
                                        if (callbacks && callbacks.handleUpdateDetalle) callbacks.handleUpdateDetalle(nuevo, item.id);
                                    }}
                                />
                            ) : (
                                <SoftTypography variant="caption" fontWeight="medium">
                                    {`$${formatMoneyPuntoDecimal(item?.precioEstimado ?? item?.materiaPrima?.precio ?? 0)}`}
                                </SoftTypography>
                            )}
                            <SoftTypography variant="caption" display="block">
                                por {item?.requierePack ? item?.unidadPack || 'pack (definir)' : item?.unidadAbreviatura || item?.materiaPrima?.tipoUnidad?.abreviatura}
                            </SoftTypography>
                        </SoftBox>
                    </Tooltip>
                )
            },
            {
                field: "totalProducto",
                headerName: "Total base",
                align: "center",
                sortable: false,
                // width: "7%",
                renderHeader: (column, isCurrentSort, direction) => (
                    <SoftBox
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        gap={1}
                        sx={{
                            width: "100%",
                            overflow: "hidden",
                            minWidth: 0,
                        }}
                    >
                        <SoftBox display="flex" alignItems="center" gap={1}>
                            <SoftTypography
                                variant="caption"
                                fontWeight="bold"
                                textTransform="uppercase"
                                color="dark"
                                sx={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    flex: 1,
                                    minWidth: 0,
                                }}
                                title={column.headerName}
                            >
                                {column.headerName}
                            </SoftTypography>
                        </SoftBox>
                    </SoftBox>
                ),
                renderCell: (item) => {
                    // Total producto representa total de MP que ingresa por la compra (unidad base)
                    const cantidad = Number(item?.cantidad) || 0; // packs si requierePack, si no MP
                    const subtotal = item?.requierePack ? cantidad * mpPorPack(item) : cantidad;
                    const unidad = item?.materiaPrima?.tipoUnidad?.abreviatura || '';
                    return (
                        // <SoftBox display="flex" alignItems="center" justifyContent='space-between'>
                        <SoftBox sx={{ width: '100%' }} display="flex" alignItems="center" justifyContent='space-around' gap={1}>
                            {(allowEdit && item?.requierePack) ? (
                                <SoftInputNumber
                                    placeholder="Total producto"
                                    name="totalProducto"
                                    value={subtotal}
                                    onChange={(e) => {
                                        let subtotalRaw = Number(e.target.value);
                                        if (isNaN(subtotalRaw) || subtotalRaw < 0) subtotalRaw = 0;

                                        const nuevo = { ...item, materiaPrima: { ...item.materiaPrima } };

                                        // cantidad = packs = subtotalMP / (mpPorPack)
                                        const mpPorPackCalc = mpPorPack(nuevo);
                                        const cantidadPacks = mpPorPackCalc > 0 ? (subtotalRaw / mpPorPackCalc) : 0;
                                        nuevo.cantidad = cantidadPacks;
                                        nuevo.totalMP = subtotalRaw;

                                        if (callbacks && callbacks.handleUpdateDetalle) callbacks.handleUpdateDetalle(nuevo, item.id);
                                    }}
                                />) : (
                                <SoftTypography variant="button" fontWeight="medium">
                                    {`${formatMoneyPunto(subtotal)} ${unidad}`}
                                </SoftTypography>)
                            }
                            {allowEdit && item?.requierePack && <SoftTypography variant="button" color="secondary">
                                {unidad || item?.materiaPrima?.tipoUnidad?.nombre || item?.materiaPrima?.tipoUnidad || 'Sin especificar'}
                            </SoftTypography>}
                        </SoftBox>
                    );
                }
            },
            {
                field: "subtotal",
                headerName: "Subtotal",
                align: "center",
                sortable: false,
                renderHeader: (column, isCurrentSort, direction) => (
                    <SoftBox
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        gap={1}
                        sx={{
                            width: "100%",
                            overflow: "hidden",
                            minWidth: 0,
                        }}
                    >
                        <SoftBox display="flex" alignItems="center" gap={1}>
                            <SoftTypography
                                variant="caption"
                                fontWeight="bold"
                                textTransform="uppercase"
                                color="dark"
                                sx={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    flex: 1,
                                    minWidth: 0,
                                }}
                                title={column.headerName}
                            >
                                {column.headerName}
                            </SoftTypography>
                        </SoftBox>
                    </SoftBox>
                ),
                renderCell: (item) => {
                    // El precio estimado es por unidad de compra: por pack si requierePack, si no por unidad de MP
                    const cantidad = Number(item?.cantidad) || 0;
                    const precioUnit = Number(item?.precioEstimado ?? item?.materiaPrima?.precio ?? 0);
                    const subtotalMoney = cantidad * precioUnit;
                    return (
                        <SoftTypography variant="button" fontWeight="medium">
                            {`$${formatMoneyPuntoDecimal(subtotalMoney)}`}
                        </SoftTypography>
                    );
                }
            },
            {
                field: "observacionFlag",
                headerName: "",
                align: "center",
                width: "4%",
                sortable: false,
                renderHeader: () => (
                    <SoftBox sx={{ width: "100%" }} />
                ),
                renderCell: (item) => (
                    <SoftBox sx={{ width: '100%' }} display="flex" alignItems="center" justifyContent="center">
                        {item?.observacion ? (
                            <Tooltip title="Ver observación" placement="top">
                                <Icon
                                    sx={{ color: getUproColor('uproYellow'), cursor: 'pointer' }}
                                    fontSize="small"
                                    onClick={() => {
                                        if (callbacks && callbacks.openObservacionDialog) callbacks.openObservacionDialog(item.id);
                                    }}
                                >
                                    visibility
                                </Icon>
                            </Tooltip>
                        ) : null}
                    </SoftBox>
                )
            },
            {
                field: "acciones",
                headerName: "",
                width: "4%",
                align: "center",
                renderCell: (item, index) => (
                    <SoftBox
                        mr={2}
                        sx={{
                            cursor: "pointer",
                        }}
                        align="center"
                    >
                        <Tooltip title="Opciones" placement="top">
                            <Icon
                                sx={{ color: getUproColor("uproGreen"), cursor: "pointer", mx: 0.5 }}
                                fontSize="small"
                                onClick={(e) => {
                                    const options = [];
                                    if (!allowEdit) {
                                        menu({
                                            open: e.target, align: 'right', options: [
                                                {
                                                    name: 'Sin acciones disponibles',
                                                    onClick: () => { },
                                                    icon: { icon: 'block', color: "secondary" }
                                                }
                                            ]
                                        });
                                        return;
                                    }
                                    // Nueva acción para cargar observación (reemplaza lógica anterior)
                                    options.push({
                                        name: 'Cargar observacion',
                                        onClick: () => {
                                            if (callbacks && callbacks.startEditObservacion) callbacks.startEditObservacion(item.id);
                                        },
                                        icon: { icon: 'edit_note', color: getUproColor('uproYellow') }
                                    });
                                    options.push({
                                        name: item?._cantidadRedondeadaManual ? 'Sin redondear' : 'Redondear',
                                        onClick: () => {
                                            if (callbacks && callbacks.toggleCantidadRedondeada) callbacks.toggleCantidadRedondeada(item.id);
                                        },
                                        icon: {
                                            icon: item?._cantidadRedondeadaManual ? 'undo' : 'rule',
                                            color: item?._cantidadRedondeadaManual ? getUproColor('uproYellow') : getUproColor('uproGreen')
                                        },
                                        hidden: item?.requierePack === true || !(Number(item?.cantidad) > 0)
                                    });
                                    options.push({
                                        name: 'Quitar item',
                                        onClick: () => {
                                            if (callbacks && callbacks.handleMarkRemove) callbacks.handleMarkRemove(item.id);
                                        },
                                        icon: { icon: 'delete', color: getUproColor('uproPink') }
                                    });
                                    menu({ open: e.target, align: 'right', options });
                                }}
                            >
                                more_vert
                            </Icon>
                        </Tooltip>
                    </SoftBox>
                ),
                renderHeader: (column, isCurrentSort, direction) => (
                    <SoftBox
                        display="flex"
                        alignItems="center"
                        gap={1}
                        sx={{
                            width: "100%",
                            overflow: "hidden",
                            minWidth: 0,
                        }}
                    >
                        <SoftTypography
                            variant="caption"
                            fontWeight="bold"
                            textTransform="uppercase"
                            color="dark"
                            sx={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                flex: 1,
                                minWidth: 0,
                            }}
                            title={column.headerName}
                        >
                            {column.headerName}
                        </SoftTypography>
                    </SoftBox>
                )
            }
        ];

        const anchos = { nombre: "300px", requierePack: "150px", cantidad: "150px", precioEstimado: "150px",
            totalProducto: "110px", subtotal: "130px", observacionFlag: "40px", acciones: "50px" };
        return baseColumns.map((column) => ({ ...column, width: anchos[column.field] || column.width }));
    } else {
        return [
            {
                field: "nombreServicio",
                headerName: "Descripción",
                align: "left",
                width: "45%",
                sortable: true,
                renderHeader: (column, isCurrentSort, direction) => (
                    <SoftBox
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        gap={1}
                        sx={{
                            width: "100%",
                            overflow: "hidden",
                            minWidth: 0,
                        }}
                    >
                        <SoftBox display="flex" alignItems="center" gap={1}>
                            <SoftTypography
                                variant="caption"
                                fontWeight="bold"
                                textTransform="uppercase"
                                color="dark"
                                sx={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    flex: 1,
                                    minWidth: 0,
                                }}
                                title={column.headerName}
                            >
                                {column.headerName}
                            </SoftTypography>
                        </SoftBox>
                    </SoftBox>
                ),
                renderCell: (item) => (
                    <SoftBox component="td" p={1} textAlign={"left"} sx={{ verticalAlign: "center" }}>
                        <SoftBox display="flex" gap={1} alignItems="center">
                            <Tooltip title={item?.rubroServicio ?? "Servicio"} placement="top">
                                <Icon fontSize="medium" sx={{ cursor: "pointer" }}>
                                    home_repair_service
                                </Icon>
                            </Tooltip>
                            <SoftBox display="flex" flexDirection="column">
                                <Tooltip enterDelay={500} title={item?.nombreServicio} placement="top">
                                    <SoftTypography variant="caption" fontWeight="medium">
                                        {recortarTexto(item?.nombreServicio, 400)}
                                    </SoftTypography>
                                </Tooltip>
                                <SoftTypography variant="caption" color="secondary">
                                    - {recortarTexto(item?.rubroServicio, 100)}
                                </SoftTypography>
                            </SoftBox>
                        </SoftBox>
                    </SoftBox>
                )
            },
            {
                field: "cantidad",
                headerName: "Cantidad",
                align: "center",
                // width: "120px",
                sortable: true,
                renderHeader: (column, isCurrentSort, direction) => (
                    <SoftBox
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        gap={1}
                        sx={{
                            width: "100%",
                            overflow: "hidden",
                            minWidth: 0,
                        }}
                    >
                        <SoftBox display="flex" alignItems="center" gap={1}>
                            <SoftTypography
                                variant="caption"
                                fontWeight="bold"
                                textTransform="uppercase"
                                color="dark"
                                sx={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    flex: 1,
                                    minWidth: 0,
                                }}
                                title={column.headerName}
                            >
                                {column.headerName}
                            </SoftTypography>
                        </SoftBox>
                    </SoftBox>
                ),
                renderCell: (item) => (
                    <SoftBox sx={{ width: "100%" }}>
                        {allowEdit ? (
                            <SoftInputNumber
                                placeholder="Cantidad"
                                name="cantidad"
                                autoComplete="off"
                                value={item?.cantidad ?? 0}
                                readOnly={false}
                                onChange={(e) => {
                                    const raw = Number(e.target.value);
                                    const val = isNaN(raw) || raw < 0 ? 0 : raw;
                                    const nuevo = {
                                        ...item,
                                        cantidad: val,
                                        cantidadVerificada: val,
                                    };
                                    if (callbacks && callbacks.handleUpdateDetalle) callbacks.handleUpdateDetalle(nuevo, item.id);
                                }}
                            />
                        ) : (
                            <SoftTypography
                                verticalAlign={"middle"}
                                variant="caption"
                                color="dark"
                                fontWeight="bold"
                            >
                                {formatMoneyPunto(item.cantidad ?? 0)}
                            </SoftTypography>
                        )}
                    </SoftBox>
                )

            },

            {
                field: "precioEstimado",
                headerName: "Precio estimado",
                align: "center",
                // width: "150px",
                sortable: true,
                renderHeader: (column, isCurrentSort, direction) => (
                    <SoftBox
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        gap={1}
                        sx={{
                            width: "100%",
                            overflow: "hidden",
                            minWidth: 0,
                        }}
                    >
                        <SoftBox display="flex" alignItems="center" gap={1}>
                            <SoftTypography
                                variant="caption"
                                fontWeight="bold"
                                textTransform="uppercase"
                                color="dark"
                                sx={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    flex: 1,
                                    minWidth: 0,
                                }}
                                title={column.headerName}
                            >
                                {column.headerName}
                            </SoftTypography>
                        </SoftBox>
                    </SoftBox>
                ),
                renderCell: (item) => (
                    <SoftBox sx={{ width: '100%' }}>
                        <Tooltip placement="top" title={"Precio estimado de compra"}>
                            <SoftBox>
                                {allowEdit ? (
                                    <SoftInputNumber
                                        autoComplete="off"
                                        placeholder="Precio"
                                        name="precioEstimado"
                                        value={item?.precioEstimado}
                                        onChange={(e) => {
                                            const nuevoDetalle = { ...item, precioEstimado: e.target.value };
                                            if (callbacks && callbacks.handleUpdateDetalle) callbacks.handleUpdateDetalle(nuevoDetalle, item.id);
                                        }}
                                        inputProps={{
                                            maxLength: 10,
                                        }}
                                    />
                                ) : (
                                    <SoftTypography
                                        verticalAlign={"middle"}
                                        variant="caption"
                                        color="dark"
                                        fontWeight="bold"
                                    >
                                        {item?.precioEstimado ? `$ ${formatMoneyPunto(item.precioEstimado)}` : "-"}
                                    </SoftTypography>
                                )}
                            <SoftTypography variant="caption" display="block">
                                por {item?.requierePack ? item?.unidadPack || 'pack (definir)' : item?.unidadAbreviatura || item?.materiaPrima?.tipoUnidad?.abreviatura}
                            </SoftTypography>
                            </SoftBox>
                        </Tooltip>
                    </SoftBox>
                )
            },
            {
                field: "subtotal",
                headerName: "Subtotal",
                sortable: true,
                renderHeader: (column, isCurrentSort, direction) => (
                    <SoftBox
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        gap={1}
                        sx={{
                            width: "100%",
                            overflow: "hidden",
                            minWidth: 0,
                        }}
                    >
                        <SoftBox display="flex" alignItems="center" gap={1}>
                            <SoftTypography
                                variant="caption"
                                fontWeight="bold"
                                textTransform="uppercase"
                                color="dark"
                                sx={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    flex: 1,
                                    minWidth: 0,
                                }}
                                title={column.headerName}
                            >
                                {column.headerName}
                            </SoftTypography>
                        </SoftBox>
                    </SoftBox>
                ),
                renderCell: (item) => (
                    <SoftBox
                        p={1}
                        textAlign={"center"}
                        borderBottom={`${borderWidth[1]} solid ${light.main}`}
                        sx={{ verticalAlign: "center", width: "100%" }}
                    >
                        <Tooltip placement="top" title={"Total Item"}>
                            <SoftTypography variant="caption" fontWeight="medium">
                                {formatMoneyPunto(
                                    (item.cantidadVerificada ?? item.cantidad ?? 0) *
                                    (item?.provisionDetalle?.precioUnitario ?? item.precioEstimado ?? 0)
                                )}
                            </SoftTypography>
                        </Tooltip>
                    </SoftBox>
                )
            },
            {
                field: "observacionFlag",
                headerName: "",
                align: "center",
                width: "4%",
                sortable: false,
                renderHeader: () => (<SoftBox sx={{ width: "100%" }} />),
                renderCell: (item) => (
                    <SoftBox sx={{ width: '100%' }} display="flex" alignItems="center" justifyContent="center">
                        {item?.observacion ? (
                            <Tooltip title="Ver observación" placement="top">
                                <Icon
                                    sx={{ color: getUproColor('uproYellow'), cursor: 'pointer' }}
                                    fontSize="small"
                                    onClick={() => {
                                        if (callbacks && callbacks.openObservacionDialog) callbacks.openObservacionDialog(item.id);
                                    }}
                                >
                                    visibility
                                </Icon>
                            </Tooltip>
                        ) : null}
                    </SoftBox>
                )
            },
            {
                field: "acciones",
                headerName: "",
                width: "5%",
                renderCell: (item, index) =>
                (
                    <SoftBox
                        mr={2}
                        sx={{
                            cursor: "pointer",
                        }}
                    >
                        <Tooltip title="Opciones" placement="top">
                            <Icon
                                sx={{ color: getUproColor("uproGreen"), cursor: "pointer", mx: 0.5 }}
                                fontSize="small"
                                onClick={(e) => menu({
                                    open: e.currentTarget,
                                    align: "right",
                                    options: [
                                        {
                                            name: 'Cargar observacion',
                                            icon: { icon: 'edit_note', color: getUproColor('uproYellow') },
                                            onClick: () => {
                                                if (callbacks && callbacks.startEditObservacion) callbacks.startEditObservacion(item.id);
                                            },
                                            hidden: !allowEdit,
                                        },
                                        {
                                            name: "Ver archivo",
                                            icon: { icon: "file_open", color: getUproColor("uproGreen") },
                                            onClick: () => {
                                                if (item?.fileUpload) {
                                                    const objectURL = URL.createObjectURL(item?.fileUpload);
                                                    window.open(objectURL, "_blank");
                                                } else {
                                                    window.open(resolveStoredFileUrl(item?.file), "_blank");
                                                }
                                            },
                                            hidden: !(item?.file || item?.fileUpload),
                                        },
                                        {
                                            name: "Cargar archivo",
                                            icon: { icon: "upload_file", color: getUproColor("uproYellow") },
                                            onClick: () => {
                                                if (callbacks && callbacks.toggleInput) callbacks.toggleInput(item.id);
                                            },
                                            hidden: !allowEdit || item?.file || item?.fileUpload,
                                        },
                                        {
                                            name: "Eliminar archivo",
                                            icon: { icon: "insert_drive_file", color: "error" },
                                            onClick: () => {
                                                if (callbacks && callbacks.handleRemoveFile) callbacks.handleRemoveFile(item.id);
                                            },
                                            hidden: !(item?.file || item?.fileUpload) || !allowEdit,
                                        },
                                        {
                                            name: "Eliminar item",
                                            icon: { icon: "close", color: "error" },
                                            onClick: () => {
                                                if (callbacks && callbacks.handleMarkRemove) callbacks.handleMarkRemove(item.id);
                                            },
                                            hidden: !allowEdit,
                                        },
                                    ],
                                })}
                            >
                                more_vert
                            </Icon>
                        </Tooltip>
                    </SoftBox>
                ),
                renderHeader: (column, isCurrentSort, direction) => (
                    <SoftBox
                        display="flex"
                        alignItems="center"
                        gap={1}
                        sx={{
                            width: "100%",
                            overflow: "hidden",
                            minWidth: 0,
                        }}
                    >
                        <SoftTypography
                            variant="caption"
                            fontWeight="bold"
                            textTransform="uppercase"
                            color="dark"
                            sx={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                flex: 1,
                                minWidth: 0,
                            }}
                            title={column.headerName}
                        >
                            {column.headerName}
                        </SoftTypography>
                    </SoftBox>
                )
            }
        ];
    }
};
